import { Environment } from '../../constants/EnvironmentsEnum'
export const isEnvironment = (env: Environment): boolean => process.env.NODE_ENV === env
